export default __webpack_public_path__ + "static/oxArena-d4c02a8ee6be9c84b4cb89df0e41925c.png";